/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DenotationPartTypeConstants = {
    String: 'String',
    InternalLink: 'InternalLink',
    ExternalLink: 'ExternalLink',
    HtmlSafe: 'HtmlSafe',
    HtmlUnsafe: 'HtmlUnsafe',
    LineBreak: 'LineBreak',
    Paragraph: 'Paragraph',
    ModalHTML: 'ModalHTML'
} as const;
export type DenotationPartTypeConstants = typeof DenotationPartTypeConstants[keyof typeof DenotationPartTypeConstants];


export function DenotationPartTypeConstantsFromJSON(json: any): DenotationPartTypeConstants {
    return DenotationPartTypeConstantsFromJSONTyped(json, false);
}

export function DenotationPartTypeConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DenotationPartTypeConstants {
    return json as DenotationPartTypeConstants;
}

export function DenotationPartTypeConstantsToJSON(value?: DenotationPartTypeConstants | null): any {
    return value as any;
}

